import { render, staticRenderFns } from "./ShowAlbum.vue?vue&type=template&id=2660b1a0&scoped=true&"
import script from "./ShowAlbum.vue?vue&type=script&lang=js&"
export * from "./ShowAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660b1a0",
  null
  
)

export default component.exports